<!-- App.svelte -->
<script>
  import Navbar from "./components/Navbar.svelte";
  import TodoList from "./components/TodoList.svelte";

  import { Navigate } from 'svelte-router-spa'

  let todos = [
    { id: 0, checked: false, text: "finish Svelte tutorial" },
    { id: 1, checked: false, text: "build an app" },
    { id: 2, checked: false, text: "world domination" },
  ];

  function handleClick() {
      alert('clicked')
  }
</script>

<section class="hero is-primary is-fullheight">
  <div class="hero-head">
    <Navbar />
  </div>

  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="columns is-desktop">
         <div class="column"></div>
   <div class="column">
     <h1 class="title">Todo List</h1>
     <h2 class="subtitle">Built with Svelte, Bulma</h2>
     <!-- 이 곳에 TodoInput 넣기 -->
     <TodoList {todos} />
   </div>
   <div>
   <button class="button is-primary is-light is-large"><Navigate to="/home">다음</Navigate></button>
   </div>
   <div class="column"></div>
      </div>
    </div>
  </div>
</section>
